import React from "react";

const ImageArrowRight = ({ className = "" }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<path
				className="image-arrow-right"
				d="m9.62 6 6.528 6.528L9.676 19H7.055l6.472-6.472L7 6h2.62z"
			/>
		</svg>
	);
};

export default ImageArrowRight;
